export const INPUT_TOOGLE = 'INPUT_TOOGLE';
export const INPUT_CHECKBOX = 'INPUT_CHECKBOX';
export const INPUT_RIGHT = 'INPUT_RIGHT';
export const INPUT_LEFT = 'INPUT_LEFT';

export interface InputWithTitleAndSubtitleTranslations {
  title: string;
  subtitle: string;
}
export interface InputWithTitleAndSubtitleProps {
  translations: InputWithTitleAndSubtitleTranslations;
  controllerName: string;
  className?: string;
  inputType: typeof INPUT_TOOGLE | typeof INPUT_CHECKBOX;
  inputPosition?: typeof INPUT_RIGHT | typeof INPUT_LEFT;
  textWidthClassname?: string;
  disabled?: boolean;
  checked?: boolean;
}
